module.exports = __webpack_public_path__ + "assets/img/2dd01c5c8629de72a5425cda6dd98efc.png";